module.exports = "/fonts/mpn-picturemark-l-242d41ea769c9354104f926e020d0ca7.svg";